import { render, staticRenderFns } from "./veStuAttendAdd.vue?vue&type=template&id=35cb2679&scoped=true"
import script from "./veStuAttendAdd.vue?vue&type=script&lang=js"
export * from "./veStuAttendAdd.vue?vue&type=script&lang=js"
import style0 from "./veStuAttendAdd.vue?vue&type=style&index=0&id=35cb2679&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cb2679",
  null
  
)

export default component.exports